import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpService } from 'src/app/core/data/service/http.service';
import { ChatMessage } from '../schema/chat-message';
import { ChatThread } from '../schema/chat-thread';
import { AuctionService } from '../service/auction.service';

@Injectable({
  providedIn: 'root'
})
export class MessagesService extends HttpService {

  @Output() threadViewEvent = new EventEmitter();

  private unreadCount = 0;
  private lastChecked;


  get unreadMessageCount() { return this.unreadCount; }
  set unreadMessageCount(value: number) {
    this.unreadCount = value;
  }

  constructor(http: HttpClient, private auctionService: AuctionService) {
    super(http);
    this.endpoint = `${this.apiURL}/messages`;

  }

  async getById(id: number) {
    return new ChatThread(await super.getById(id));
  }

  async fetchThreads(userId?: number, productId?: number) {
    const url = `${this.endpoint}/auction/${this.auctionService.currentAuction.auctionId}/${userId || 0}/${productId || 0}`;
    let threads = await this.fetch(url) as ChatThread[];
    threads = threads.map(m => new ChatThread(m));
    return threads;
  }

  async fetchAllThreads(userId?: number) {
    const url = `${this.endpoint}/allthreads/${userId}`;
    let threads = await this.fetch(url) as ChatThread[];
    threads = threads.map(m => new ChatThread(m));
    return threads;
  }

  async getUnreadMessageCount() {
    // if it's been > 30 seconds since we last checked, get the count or we haven't checked yet
    if (!this.lastChecked || (new Date().getTime() - this.lastChecked.getTime()) > 30000) {
      console.log('Getting unread message count');
      try {
        this.unreadCount = await this.fetch(`${this.endpoint}/unread/${this.auctionService.currentAuction.auctionId}`) as number;
        console.log('Unread message count: ', this.unreadCount);
        this.lastChecked = new Date();
      }
      catch (error) {
        console.error('Error getting unread message count: ', error);
        return 0;
      }
    }
    return this.unreadCount;
  }

  async getByProductId(id: number) {
    return new ChatThread(await super.getById(id, `${this.endpoint}/product`));
  }

  async getByAuctionUser(userId: number) {
    return new ChatThread(await this.fetch(`${this.endpoint}/user/${userId}/${this.auctionService.currentAuction.auctionId}`));
  }

  async send(message: ChatMessage) {
    return this.post(message, this.endpoint);
  }

  protected isUpdate(entity: any): boolean {
    throw new Error('Method not implemented.');
  }

  protected getUpdateUrl(entity: any): string {
    throw new Error('Method not implemented.');
  }
}
